<template>
  <div class="relative bg-white px-4 xs:py-10 lg:py-18 xs:px-4 sm:px-6 lg:px-8">
    <section class="relative mx-auto max-w-6.5xl review-section">
      <header class="text-center">
        <h2 class="h2 font-alt text-gray-900 !tracking-normal">{{ title }}</h2>
        <p class="mt-4 text-gray-600 text-lg">{{ description }}</p>
      </header>
      <client-only>
        <Carousel
          class="xs:pt-8 lg:pt-16 in-media-container-outer"
          wrapper-classes="review-container-wrapper"
          :slides-per-view="slidesPerView"
        >
          <SwiperSlide class="flex carousel-slide !h-auto" v-for="{ id, logoSrc, logoClass, mediaLink, quote, description } in items" :key="id">
            <MediaItem
              :logo-src="logoSrc"
              :logo-class="logoClass"
              :media-link="mediaLink"
              :quote="quote"
              :description="description"
            />
          </SwiperSlide>
        </Carousel>
      </client-only>
    </section>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { CarouselSlidesPerViewType } from '@/types/carousel-types'
import { MediaItemTypes } from "~/types/media-types";

const { SwiperSlide } = await import('swiper/vue')

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  items: {
    type: Array as PropType<MediaItemTypes>,
    default: () => [],
  }
})

const slidesPerView = computed<CarouselSlidesPerViewType>(() => ({ mobile: '1', tablet: '2', desktop: '3' }))
</script>

<style lang="scss">
.carousel-container-outer.review-container-outer {
  .swiper-pagination {
    @apply mt-8;

    @screen lg {
      @apply mt-16;
    }
  }
}

.carousel-container-outer.in-media-container-outer {
  .w-\[240px\] {
    width: 340px;
  }
}
</style>
